import styled from 'styled-components';


export const Wrapper = styled.div`
    padding-bottom:2px;
    border-bottom: 2px solid var(--lightGreen);
    .title{
        background-color:var(--lightGreen);
    }
`;